import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

//Table
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../../../utils/MyTable';

import { useDispatch } from "react-redux";
import { headerSearch, unoTheme } from "../../../../assets/styles/unoTheme";
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../../controllers/ExcelController";
import allActions from '../../../../actions';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        width: '100%',
    },
    headerSearch: headerSearch,

    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableContainer: {
        padding: '0px 18px 16px 18px',
        borderRadius: '10px 0px 0px 10px',
    },
    table: {
        tableLayout: 'fixed',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                backgroundColor: 'white',
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },
    clickableHead: {
        cursor: 'pointer',
    },
    accordionNewClient: {
        marginBottom: theme.spacing(2),
    },
    heading: {
        display: 'flex',
        alignItems: 'center'
    },
    labelHeading: {
        marginTop: '2px'
    },
    rootForm: {
        // '& .MuiTextField-root': {
        //     margin: theme.spacing(1),
        //     width: '25ch',
        // },
        textAlign: "left",
    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },
    myDatePicker: {
        marginTop: '-6px'
    },
    green: {
        color: unoTheme.greenMoney
    },

    leftChart: {
        padding: theme.spacing(2),
        width: '50%',
    },

    leftHeaderDetail: {
        display: "flex",
        alignItems: "baseline",
    },
    rightHeader: {
        display: 'flex',
        alignItems: 'center',
    },

    //RightDiv
    mainRoot: {
        height: '100%',
        width: '100%',
        transition: 'all .3s ease',
    },

    sectionTableCellData: {
        width: '30%',
        display: 'table-cell',
        padding: '0px !important',
        fontSize: '12px',
    },

    sectionTableCell: {
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
        fontSize: '12px',
    },
    multipleHorizontalTableCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        '& > div': {
            width: '50%',
        }
    },

}));

//Colunas BACEN removidas temporariamente: descomentar junto com as células de Bacen
//Cor da validação binária (Sim/Não) da segmentação Bacen
// function binaryColor(value) {
//
//     if (value === 'Sim') {
//         return unoTheme.greenMoney;
//     }
//
//     if (value === 'Não') {
//         return unoTheme.redMoney;
//     }
//
//     return unoTheme.defaultTextColor;
// }

//Coluna APTO removida temporariamente: descomentar junto com as células de Apto
//Cor do status de aptidão do fundo
// function aptoColor(isApto) {
//
//     if (isApto === true) {
//         return unoTheme.greenMoney;
//     }
//
//     if (isApto === false) {
//         return unoTheme.redMoney;
//     }
//
//     return unoTheme.defaultTextColor;
// }

export default function RiskArticlesScreen(props) {

    const { data, flagDoExcelRiskArticles, resetFlag } = props;

    const classes = useStyles();

    const dispatch = useDispatch();

    useEffect(() => {
        if (flagDoExcelRiskArticles) {
            if (data && data.length > 0) {
                doExcelRiskArticles(
                    "ENQUADRAMENTOS_RISCO_" + new Date().toISOString().split('T')[0],
                    data
                );
            }
            resetFlag();
        }
    }, [flagDoExcelRiskArticles, data, resetFlag]);

    function doExcelRiskArticles(titleFile, articlesData) {
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha de Enquadramentos...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Enquadramentos de Risco",
            Author: "UNO",
        }
        const sheetName = "Enquadramentos Risco";
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        // Cabeçalhos
        ws_data.push([
            'Fundo',
            'Art. 18',
            'Art. 19',
            'Gestor',
            //Colunas BACEN removidas temporariamente
            //'Bacen S1/S2',
            'Art. 20',
            'Administrador',
            //'Bacen S1/S2',
            'Art. 21',
            //Coluna APTO removida temporariamente
            //'Apto',
            'Res.'
        ]);

        // Dados
        articlesData.forEach(row => {
            ws_data.push([
                row.full_fund_name ? row.full_fund_name : row.fund_name,
                row.art18,
                row.art19,
                row.manager_name,
                //Colunas BACEN removidas temporariamente
                //row.manager_bacen ? row.manager_bacen : '-',
                row.art20,
                row.administrator_name,
                //row.administrator_bacen ? row.administrator_bacen : '-',
                row.art21,
                //Coluna APTO removida temporariamente
                //row.aptoLabel ? row.aptoLabel : '-',
                row.device_abbreviation
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), titleFile + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    return (
        <div className={classes.root}>

            <div className={classes.mainRoot}>
                <div class={'defaultScrollWithHeaderContent'}>
                    <div>
                        <MyTable
                            stickyHeader>
                            <colgroup>
                                <col width="22%" />
                                <col width="7%" />
                                <col width="7%" />
                                <col />
                                {/* Coluna BACEN removida temporariamente */}
                                {/* <col width="7%" /> */}
                                <col width="7%" />
                                <col />
                                {/* Coluna BACEN removida temporariamente */}
                                {/* <col width="7%" /> */}
                                <col width="7%" />
                                {/* Coluna APTO removida temporariamente */}
                                {/* <col width="9%" /> */}
                                <col width="7%" />
                            </colgroup>
                            <TableHead>
                                <TableRow>

                                    <TableCell align="left">Fundo</TableCell>
                                    <TableCell align="center">Art. 18</TableCell>
                                    <TableCell align="center">Art. 19</TableCell>
                                    <TableCell align="left">Gestor</TableCell>
                                    {/* Coluna BACEN removida temporariamente */}
                                    {/* <TableCell align="center">Bacen</TableCell> */}
                                    <TableCell align="center">Art. 20</TableCell>
                                    <TableCell align="left">Administrador</TableCell>
                                    {/* Coluna BACEN removida temporariamente */}
                                    {/* <TableCell align="center">Bacen</TableCell> */}
                                    <TableCell align="center">Art. 21</TableCell>
                                    {/* Coluna APTO removida temporariamente */}
                                    {/* <TableCell align="center">Apto</TableCell> */}
                                    <TableCell align="center"></TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data.map((row, index) => (
                                    <TableRow key={'diarys-' + index}>


                                        <TableCell align="left">{row.fund_name}</TableCell>
                                        <TableCell align="center" style={{ color: row.outArt18 ? unoTheme.redMoney : unoTheme.greenMoney }}>{row.art18}</TableCell>
                                        <TableCell align="center" style={{ color: row.outArt19 ? unoTheme.redMoney : unoTheme.greenMoney }}>{row.art19}</TableCell>
                                        <TableCell align="left">{row.manager_name}</TableCell>
                                        {/* Coluna BACEN removida temporariamente */}
                                        {/* <TableCell align="center" style={{ color: binaryColor(row.manager_bacen) }}>{row.manager_bacen ? row.manager_bacen : '-'}</TableCell> */}
                                        <TableCell align="center" style={{ color: row.outArt20 ? unoTheme.redMoney : unoTheme.greenMoney }}>{row.art20}</TableCell>
                                        <TableCell align="left">{row.administrator_name}</TableCell>
                                        {/* Coluna BACEN removida temporariamente */}
                                        {/* <TableCell align="center" style={{ color: binaryColor(row.administrator_bacen) }}>{row.administrator_bacen ? row.administrator_bacen : '-'}</TableCell> */}
                                        <TableCell align="center" style={{ color: row.outArt21 ? unoTheme.redMoney : unoTheme.greenMoney }}>{row.art21}</TableCell>
                                        {/* Coluna APTO removida temporariamente */}
                                        {/* <TableCell align="center" style={{ color: aptoColor(row.isApto) }}>{row.aptoLabel ? row.aptoLabel : '-'}</TableCell> */}
                                        <TableCell align="center" >{row.device_abbreviation}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </MyTable>
                    </div>

                </div>


            </div>

        </div>
    );
}



